export interface NavItem {
  href: string;
  label: string;
  icon: string; // SVG path d attribute for a 24x24 viewBox
  overflow?: boolean; // true = hidden on mobile bottom bar, shown in "More" sheet
  /**
   * LOT 116 — Module additionnel optionnel (Intermittence, Clients) :
   * affiché uniquement si le flag correspondant est activé dans les
   * Réglages, et visuellement différencié dans la barre de navigation
   * (trait bleu sous l'icône) pour bien le distinguer des onglets
   * principaux.
   * LOT 248 — Ajout du module "groupeAmis" (top-level, pas un sub-module
   * de Revenus comme Intermittence/Clients qui restent imbriqués).
   */
  subModule?: "intermittence" | "portefeuille";
  /**
   * LOT 252 — Module top-level optionnel (Groupe d'amis) : affiché
   * comme un onglet principal au même niveau que Revenus, mais
   * conditionnel selon le flag.
   */
  optionalModule?: "groupeAmis";
}

// Budget sub-pages
// REFONTE v2 — Onglets du module GESTIC LIGHT.
// Le « Prévisionnel » en est retiré : il projetait les revenus récurrents
// et les budgets, soit des moyennes mensuelles — une courbe qui ne disait
// rien de plus que ce que l'on avait saisi. La trésorerie détaillée reste
// dans le module Budget, où elle a le contexte pour être lue.
export const lightTabs: NavItem[] = [
  {
    href: "/light",
    label: "Vue d'ensemble",
    icon: "M20.24 12.24a6 6 0 00-8.49-8.49L5 10.5V19h8.5l6.74-6.76zM16 8L2 22M17.5 15H9",
  },
  {
    href: "/light/possessions",
    label: "Possessions",
    icon: "M3 7l9-4 9 4M3 7v10l9 4 9-4V7M3 7l9 4m0 0l9-4m-9 4v10",
  },
  {
    href: "/light/repartition",
    label: "Répartition des dépenses",
    icon: "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055zM20.488 9H15V3.512A9.025 9.025 0 0120.488 9z",
  },
  {
    href: "/light/amis",
    label: "Groupe d'amis",
    icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z",
  },
];

export const budgetTabs: NavItem[] = [
  {
    href: "/budget",
    label: "Dashboard",
    icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1",
  },
  // LOT 192 — Possessions = épargne + patrimoine financier (actions) + corporel (biens)
  {
    href: "/budget/possessions",
    label: "Possessions",
    icon: "M3 7l9-4 9 4M3 7v10l9 4 9-4V7M3 7l9 4m0 0l9-4m-9 4v10",
  },
  {
    href: "/budget/depenses",
    label: "Depenses run",
    icon: "M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z",
  },
  {
    href: "/budget/fixes",
    label: "Dep. Fixes",
    icon: "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z",
  },
  {
    href: "/budget/budgets",
    label: "Budgets",
    icon: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z",
  },
  {
    href: "/budget/revenus",
    label: "Revenus",
    icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1",
  },
  // LOT 116 — Modules additionnels (visibles uniquement si activés
  // dans Réglages → Modules). Marqués `subModule` pour le rendu
  // visuel différencié (trait bleu sous l'icône).
  {
    href: "/budget/intermittence",
    label: "Intermit.",
    icon: "M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z",
    subModule: "intermittence",
  },
  {
    href: "/budget/portefeuille",
    label: "Clients",
    icon: "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    subModule: "portefeuille",
  },
  // LOT 248 / 252 — Module "Groupe d'amis" : onglet TOP-LEVEL (pas
  // imbriqué sous Revenus) au même niveau que les onglets principaux.
  // Le label dynamique vient du custom_label en Réglages.
  {
    href: "/budget/amis",
    label: "Amis",
    icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
    optionalModule: "groupeAmis",
  },
  {
    href: "/budget/reglages",
    label: "Reglages",
    icon: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z",
  },
];

// Music sub-pages
export const musicTabs: NavItem[] = [
  {
    href: "/music",
    label: "Groupes",
    icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
  },
  {
    href: "/music/repertoire",
    label: "Repertoire",
    icon: "M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2z",
  },
  {
    href: "/music/recordings",
    label: "Recordings",
    icon: "M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z",
  },
  {
    href: "/music/patches",
    label: "Patches",
    icon: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4",
  },
  {
    href: "/music/matos",
    label: "Matos",
    icon: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z",
    overflow: true,
  },
  {
    href: "/music/calendrier",
    label: "Calendrier",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    overflow: true,
  },
];

// Module Voiture — page unique (véhicules + échéances + entretien + carburant)
export const voitureTabs: NavItem[] = [
  {
    href: "/voiture",
    label: "Mes véhicules",
    icon: "M5 11l1.6-4.8A2 2 0 018.5 5h7a2 2 0 011.9 1.2L19 11m-14 0h14a2 2 0 012 2v3a1 1 0 01-1 1h-1m-15-6a2 2 0 00-2 2v3a1 1 0 001 1h1m2 0h8M7 17a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm13 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
  },
];

// Module Vélo — page unique (fiche + pièces + interventions + kilométrage)
export const disposTabs: NavItem[] = [
  {
    href: "/dispos",
    label: "Mes groupes",
    icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
  },
];

export const veloTabs: NavItem[] = [
  {
    href: "/velo",
    label: "Mes vélos",
    icon: "M5 17.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm14 0a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM5 14l4-8h5m-3 8l4-8m0 0h3m-3 8h5",
  },
];

// Module Santé — page unique (timeline + RDV + suivis + dossiers)
export const santeTabs: NavItem[] = [
  {
    href: "/sante",
    label: "Ma santé",
    icon: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z",
  },
];

// Module Rando — sub-pages
export const randoTabs: NavItem[] = [
  {
    href: "/rando",
    label: "Vue",
    icon: "M3 12l9-9 9 9M5 10v10h14V10",
  },
  {
    href: "/rando/matos",
    label: "Matos",
    icon: "M9 5h6l1 2H8L9 5zm-2 4h10v11a1 1 0 01-1 1H8a1 1 0 01-1-1V9zm0 0V7a2 2 0 012-2h6a2 2 0 012 2v2",
  },
  {
    href: "/rando/routes",
    label: "Randos",
    icon: "M3 21l4-7 5 4 4-6 5 9M3 21h18",
  },
  {
    href: "/rando/groupes",
    label: "Groupes",
    icon: "M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-5.13a4 4 0 11-8 0 4 4 0 018 0zm6 0a4 4 0 11-8 0 4 4 0 018 0z",
  },
];
